import { useState } from "react";
import { MoveHorizontal, Info } from "lucide-react";
import { BEFORE_AFTER } from "@/data/site";
import { SectionHead, Reveal } from "./Reveal";

const Slider = ({ pair }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative overflow-hidden rounded-[24px] lg:rounded-[32px] aspect-[4/5] sm:aspect-[3/2] bg-[#DDE3D5] select-none" data-testid="before-after-slider">
      <img src={pair.after} alt={`Nachher: ${pair.label}`} className="absolute inset-0 w-full h-full object-cover" draggable="false" />
      <img src={pair.before} alt={`Vorher: ${pair.label}`} className="absolute inset-0 w-full h-full object-cover" draggable="false"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
      <span className="absolute top-4 left-4 rounded-full bg-black/60 backdrop-blur-md text-white text-xs font-medium uppercase tracking-[0.14em] px-3 py-1.5">Vorher</span>
      <span className="absolute top-4 right-4 rounded-full bg-white/85 backdrop-blur-md text-[#111511] text-xs font-medium uppercase tracking-[0.14em] px-3 py-1.5">Nachher</span>
      <div className="absolute inset-y-0 w-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white text-[#111511] shadow-xl flex items-center justify-center">
          <MoveHorizontal className="w-5 h-5" />
        </span>
      </div>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} aria-label="Vorher-Nachher-Regler"
        data-testid="before-after-range" className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" />
      {pair.example && (
        <span data-testid="before-after-example-badge" className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 text-[#111511] text-xs font-medium px-3 py-1.5 pointer-events-none">
          <Info className="w-3.5 h-3.5" /> Beispielbild
        </span>
      )}
    </div>
  );
};

export const BeforeAfter = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="vorher-nachher" data-testid="before-after-section" className="py-24 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <SectionHead eyebrow="Vorher / Nachher" lines={["Der Unterschied", <span className="text-[#5E8C3A]">auf einen Blick.</span>]}
          text="Ziehen Sie den Regler, um zu sehen, was regelmäßige Gartenpflege bewirkt." />
        <Reveal className="mt-12 lg:mt-16">
          <div className="flex gap-2 mb-5 overflow-x-auto">
            {BEFORE_AFTER.map((p, i) => (
              <button key={p.key} onClick={() => setActive(i)} data-testid={`before-after-tab-${p.key}`}
                className={`shrink-0 rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-300 ${active === i ? "bg-[#111511] text-white" : "bg-[#F1F3EC] text-[#30352F] hover:bg-[#E4EED6]"}`}>
                {p.label}
              </button>
            ))}
          </div>
          <Slider key={BEFORE_AFTER[active].key} pair={BEFORE_AFTER[active]} />
          {BEFORE_AFTER.some((p) => p.example) && (
            <p className="mt-4 text-sm text-[#5B615A]">Hinweis: Beispielbilder zur Veranschaulichung – eigene Fotos von K&amp;A Gartenservice folgen.</p>
          )}
        </Reveal>
      </div>
    </section>
  );
};
